module["exports"] = [
  "#####",
  "#####-####"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/address/postcode_by_state.js
 ** module id = 290
 ** module chunks = 0
 **/